<h2 mat-dialog-title class="text-white">Session Expired</h2>
    <mat-dialog-content class="text-white">Your session has expired. Please log in again.</mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()" class="btn btn-grad-ff ms-2">OK</button>
    </mat-dialog-actions>